import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DayHeaderContentArg } from '@fullcalendar/core';
import { ContextMenuComponent } from '@perfectmemory/ngx-contextmenu';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'rk-planning-day-header',
  templateUrl: './planning-day-header.component.html',
  styleUrls: ['./planning-day-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningDayHeaderComponent implements OnInit, OnDestroy {
  dayHeaderContentArg$: BehaviorSubject<DayHeaderContentArg> = new BehaviorSubject(null);

  dayHeaderContents$: Observable<{ date: string; day: string }>;

  protected dayHeaderContentArg: DayHeaderContentArg;

  @ViewChild('ctxMenu')
  contextMenu: ContextMenuComponent;

  subscription = new Subscription();

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  getElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.dayHeaderContentArg$.subscribe(
        dayHeaderContentArg => (this.dayHeaderContentArg = dayHeaderContentArg),
      ),
    );

    this.dayHeaderContents$ = this.dayHeaderContentArg$.pipe(
      filter(dayHeaderContentArg => !!dayHeaderContentArg),
      map(dayHeaderContentArg => {
        const parts = dayHeaderContentArg.text.split(' ');
        const [day, date] = [parts[0] ?? '', parts[1] ?? ''];

        return { day, date };
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
